import React, { useEffect, useState } from 'react';

import useVersionCheck from '~hooks/useVersionCheck';
import { skipWaitingAndReload } from '~helpers/swUpdate';

const defaultState = {
  updateAvailable: false,
  latestBuildId: null,
  forced: false,
  swWaiting: false,
  applyUpdate: () => {},
};

export const UpdateContext = React.createContext(defaultState);

// Runs the version check once for the whole tree and shares whether a newer
// frontend build is available - either detected by polling or by a waiting
// service worker - so any component can offer a refresh.
const UpdateProvider = ({ children }) => {
  const versionState = useVersionCheck();
  const [swWaiting, setSwWaiting] = useState(false);

  useEffect(() => {
    const onUpdateReady = () => setSwWaiting(true);
    window.addEventListener('swUpdateReady', onUpdateReady);
    return () => window.removeEventListener('swUpdateReady', onUpdateReady);
  }, []);

  const value = {
    ...versionState,
    updateAvailable: versionState.updateAvailable || swWaiting,
    swWaiting,
    applyUpdate: () => skipWaitingAndReload(),
  };

  return <UpdateContext.Provider value={value}>{children}</UpdateContext.Provider>;
};

export default UpdateProvider;
